import chroma from 'chroma-js';
import { ReservedMembersType } from '#types/schedule';

const colorPalette = [
  '#EBCAA6',
  '#AFC7EE',
  '#F4AFB2',
  '#E5A2DF',
  '#D1EBA6',
  '#B4A6EB',
  '#7DDFD3',
  '#90E2F4',
  '#A6EBB5',
  '#A975FF',
  '#DFFBE5',
  '#E7D9FF',
  '#E9EBA6',
  '#F1CA64',
  '#F37B98',
  '#FF7F77',
  '#FF8AC2',
  '#FFCED7'
];

const personColors: { [key: string]: string } = {};
const usedColors: Set<string> = new Set();

function getRandomColorFromPalette() {
  const availableColors = colorPalette.filter(color => !usedColors.has(color));
  if (availableColors.length === 0) {
    // 모든 색상이 사용된 경우, 사용된 색상을 초기화하고 다시 사용합니다.
    usedColors.clear();
    availableColors.push(...colorPalette);
  }
  const randomColor =
    availableColors[Math.floor(Math.random() * availableColors.length)];
  usedColors.add(randomColor);
  return randomColor;
}

export function getRandomColorWithModifiedSaturation(personId: string) {
  if (personColors[personId]) {
    return personColors[personId];
  }

  // 색상 팔레트에서 무작위 색상 선택
  const randomColor = getRandomColorFromPalette();

  // 무작위 채도 변화를 위한 범위 설정 (예: 0.5 ~ 1.5)
  const saturationChange = 0.5 + Math.random();

  // 선택된 색상의 채도를 무작위로 조절
  const newColor = chroma(randomColor).set('hsl.s', saturationChange);

  // 새 색상 코드를 personColors 객체에 캐시
  personColors[personId] = newColor.hex();

  // 새 색상 코드를 반환
  return newColor.hex();
}
